import SideBar from "../SideBar";

const PageLayout = ({ children }) => {
  return (
    <div className="flex flex-col md:flex-row h-screen bg-[#1A1A1A] text-white">
      <SideBar />
      <main className="flex-1 p-6 space-y-6 relative">{children}</main>
    </div>
  );
};

export default PageLayout;
